<template>
	<span>
		<v-alert v-if="field.type === 'message'" border="left" text color="info">{{field.message}}</v-alert>

		<v-text-field v-if="field.type === 'text' && !field.hidden && !field.multiline" type="email" :label="label" :value="value" @input="$emit('input', $event)" :disabled="field.disabled" clearable :hint="field.hint" :rules="rules">
		</v-text-field>

		<v-textarea v-else-if="field.type === 'text' && !field.hidden && field.multiline" rows="1" auto-grow  type="email" :label="label" :value="value" @input="$emit('input', $event)" :disabled="field.disabled" clearable :hint="field.hint" :rules="rules">
		</v-textarea>

		<v-text-field v-if="field.type === 'password' && !field.hidden" type="password" :label="label" :value="value" @input="$emit('input', $event)" :disabled="field.disabled" clearable :hint="field.hint" :rule="rules"></v-text-field>
        <v-textarea v-if="field.type === 'textarea'" :label="label" :value="value" @input="$emit('input', $event)" clearable :disabled="field.disabled" :hint="field.hint"></v-textarea>

		<v-select v-if="field.type === 'select' && !field.hidden" :label="label" :value="value" @change="$emit('input', $event)" :items="fieldSelectList" item-text="label" item-value="value" :multiple="field.multiple" chips clearable :disabled="field.disabled" :hint="field.hint" persistent-hint :rules="rules"></v-select>
		<v-combobox v-if="field.type === 'select' && field.allowCreate" :label="label" :value="value" @change="$emit('input', $event)" :items="fieldSelectList" item-text="label" item-value="value" multiple :auto-select-first="field.defaultFirstOption" chips clearable :disabled="field.disabled" :hint="field.hint" persistent-hint></v-combobox>
		<div v-if="field.type === 'checkbox' && !field.hidden" class="cx-checkbox" >
			<p>{{field.name}}</p>
			<div v-for="listItem in field.list" :key="listItem.value">
				<v-checkbox :class="[checkboxGroupClass]" @click="validateCheckboxRequired" :disabled="field.disabled" :label="listItem.label" :value="listItem.value" @change="updateCheckbox($event, listItem.label)" :rules="rules"></v-checkbox>
			</div>
			<div v-show="field.required && !isCheckboxesValid" style="line-height: 12px;font-size: 12px;padding-top: .3rem;" class="v-messages__message red--text">Atleast one option is required.</div>
			<v-list-item-subtitle>{{field.hint}}</v-list-item-subtitle>
			<v-checkbox :class="[checkboxGroupValidatorClass]" style="display: none;" key="is-valid" label="Is valid" value="is valid" :rules="field.required ? [validateCheckboxRequired] : []"></v-checkbox>
		</div>
		<v-radio-group v-if="field.type === 'radio' && !field.hidden" @change="$emit('input', $event)" row :rules="rules">
			<div>
				<p>{{label}}</p>
				<v-radio v-for="listItem in field.list" :key="listItem.value" :value="listItem.value" :disabled="field.disabled">
					<template v-slot:label>
						<p>{{listItem.label}}</p>
					</template>
				</v-radio>
			</div>
		</v-radio-group>
		<v-switch v-if="field.type === 'switch'" :label="label" :value="value" @change="$emit('input', $event)"></v-switch>

		<!-- datetime, datetimerange Pending -->
		<v-menu v-if="field.type === 'date' || field.type === 'daterange'" v-model="showCalendar" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
			<template v-slot:activator="{ on, attrs }">
				<v-text-field :label="label" :value="value" @input="$emit('input', $event)" :placeholder="field.type.includes('range') ? 'Date Range' : 'Date'" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" clearable :disabled="field.disabled"></v-text-field>
			</template>
			<v-date-picker :value="value" @input="$emit('input', $event)" :range="field.type === 'daterange'"></v-date-picker>
		</v-menu>
	</span>
</template>
<style>
.cx-checkbox .v-messages {
	display: none;
}
.cx-checkbox .v-input__slot {
	margin-bottom: 0 !important;
}
</style>
<script>
export default {
	props: [
		'name',
		'schema',
		'value'
		// 'disabled',
		// 'list',
		// 'dependent',
		// 'dateTimePickerOptions',
		// 'datePickerOptions',
		// 'bulk'
	],
	data () {
		return {
			showCalendar: false,
			isCheckboxesValid: false, /* Whether or not the checkboxes are valid. */
			checkboxValue: {}
		}
	},
	methods: {
		validatePattern (value, pattern, errorMessage) {
			if (!value) return true
			return pattern.test(value) || errorMessage
		},
		validateEmail (value) {
			const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			return this.validatePattern(value, pattern, 'Invalid e-mail.')
		},
		validateRequired (value) {
			return !!value || 'Required.'
		},
		validateDate (value) {
			/* Date Format => dd/mm/yyyy */
			const pattern = /^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]\d{4}$/
			return this.validatePattern(value, pattern, 'Invalid date.')
		},
		validateWebsite (value) {
			const pattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})(\/[\w]*)*$/
			return this.validatePattern(value, pattern, 'Invalid Website.')
		},
		/**
		 * Validates Both IPv4 and compressed IPv6 addresses.
		 */
		validateIp (value) {
			const pattern = /^((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-fA-F]|[a-fA-F][a-fA-F0-9-]*[a-fA-F0-9])\.)*([A-Fa-f]|[A-Fa-f][A-Fa-f0-9-]*[A-Fa-f0-9])$|^(?:(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){6})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:::(?:(?:(?:[0-9a-fA-F]{1,4})):){5})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:(?:[0-9a-fA-F]{1,4})):){4})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,1}(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:(?:[0-9a-fA-F]{1,4})):){3})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,2}(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:(?:[0-9a-fA-F]{1,4})):){2})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,3}(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:[0-9a-fA-F]{1,4})):)(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,4}(?:(?:[0-9a-fA-F]{1,4})))?::)(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,5}(?:(?:[0-9a-fA-F]{1,4})))?::)(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,6}(?:(?:[0-9a-fA-F]{1,4})))?::)))))$/
			return this.validatePattern(value, pattern, 'Invalid IP address.')
		},
		validateHostName (value) {
			const pattern = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9-]*[A-Za-z0-9])$/
			return this.validatePattern(value, pattern, 'Invalid host name.')
		},
		/**
		 * Validates A phone number with mandatory country code
		 */
		validatePhone (value) {
			const pattern = /^([+]\d{1,2}[-\s]?|)\d{3}[-\s]?\d{3}[-\s]?\d{4}$/
			return this.validatePattern(value, pattern, 'Invalid phone number.')
		},
		/**
		 * Validates A phone number with mandatory country code
		 */
		validateRegex (value) {
			/* Suggestion: The Regex should be an object that contains the expression and the modifier seperately. */
			/* If regex pattern starts with a '/' then it is in literal notation and could have modifiers */
			const pattern = new RegExp(this.field.regex)
			const regexMessage = this.field.regex_message && this.field.regex_message.trim().length ? this.field.regex_message : 'Invalid pattern.'
			return this.validatePattern(value, pattern, regexMessage)
		},
		/**
		 * Validates A user's password
		 */
		validatePassword (value) {
			const pattern = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])[a-zA-Z0-9]{6,10}$/
			return this.validatePattern(value, pattern, 'Password should be 6 to 10 characters long and should consist of lowercase, uppercase characters and numbers.')
		},
		/**
		 * Checks from a group of checkboxes, to determine whether or not
		 * one of them has been selected.
		 */
		validateCheckboxRequired (value) {
			const checkboxes = [...document.getElementsByClassName(this.checkboxGroupClass)]
			if (!checkboxes && !checkboxes.length) {
				this.isCheckboxesValid = false
				return 'Atleast one option is required.'
			}
			const isValid = checkboxes.reduce((isChecked, el) => {
				if (!isChecked) {
					isChecked = el.querySelectorAll('input')[0].checked
				}
				return isChecked
			}, false)
			if (isValid) {
				this.isCheckboxesValid = true
				return true
			} else {
				this.isCheckboxesValid = false
				return 'Atleast one option is required.'
			}
		},
		updateCheckbox (val, label = '') {
			if (!label.trim().length) this.throwErr('Checkbox label cannot be empty.')
			this.checkboxValue[label] = val
			this.$emit('input', this.checkboxValue)
		}
	},
	watch: {
		/**
		* Watches if the checkbox validity changes and then dynamically changes the status of the
		* invisible checboxes that is used to validate a group of checkboxes.
		*/
		isCheckboxesValid (newVal) {
			document.getElementsByClassName(this.checkboxGroupValidatorClass)[0].querySelectorAll('input')[0].click()
		}
	},
	mounted () {
		if (!this.field) return
		/**
		 * Add the checkbox labels to the checkboxValue
		 * object in order to represent all theposible options
		 */
		if (this.field && this.field.type === 'checkbox') {
			this.field.list.forEach(val => {
				this.checkboxValue[val.label] = null
			})
		}
	},
	computed: {
		dateHint () {
			return this.field.hint.trim() ? this.field.hint : 'Date Format: DD/MM/YYYY'
		},
		field () {
			const field = this.schema.find(col => col.name === this.name)
			/* Set the Date hint if it not set */
			if (field.validation === 'date' && !field.hint) field.hint = 'Date format: DD/MM/YYYY'
			return field
		},
		checkboxGroupClass () {
			return `checkbox-group ${this.field.name.toLowerCase().replace(' ', '-').trim()}`
		},
		checkboxGroupValidatorClass () {
			return `${this.checkboxGroupClass}-validator`
		},
		activeCheckbox () {
			if (!this.$refs) return
			let checkboxList = []
			for (const checkboxGroup in this.$refs) {
				checkboxList = checkboxGroup
			}
			return checkboxList /* this.$refs[this.checkboxId] */
		},
		label () {
			// if (this.field.labelWidth === '0') return ''
			// if (this.field.type === 'checkbox' && !this.field.multiple && !this.field.trueLabel) return ''
			return this.field.label || ''
		},
		fieldSelectList () {
			if (!this.field.list) return
			// if (Array.isArray(this.list)) return this.list
			// if (Array.isArray(this.field.list)) {
			return this.field.list
				.map(row => ({ label: row.label || row.value, value: row.value }))
		},
		rules () {
			const rules = []
			if (this.field.required && this.field.type !== 'checkbox') rules.push(this.validateRequired)
			switch (this.field.validation) {
			case 'email':
				rules.push(this.validateEmail)
				break
			case 'password':
				rules.push(this.validatePassword)
				break
			case 'date':
				rules.push(this.validateDate)
				break
			case 'website':
				rules.push(this.validateWebsite)
				break
			case 'ip':
				rules.push(this.validateIp)
				break
			case 'hostName':
				rules.push(this.validateHostName)
				break
			case 'phone':
				rules.push(this.validatePhone)
				break
			case 'regex':
				rules.push(this.validateRegex)
				break
			}
			return rules
		}
	}
}
</script>
